export const RLogo = ({ height = 12, width = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1304_21758)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.98946 9.95343C4.02898 9.95343 0.818359 7.87219 0.818359 5.30485C0.818359 2.73749 4.02898 0.65625 7.98946 0.65625C11.95 0.65625 15.1606 2.73749 15.1606 5.30485C15.1606 7.87219 11.95 9.95343 7.98946 9.95343ZM9.08712 2.47369C6.07681 2.47369 3.63646 3.89652 3.63646 5.65166C3.63646 7.40681 6.07681 8.82964 9.08712 8.82964C12.0974 8.82964 14.319 7.85689 14.319 5.65166C14.319 3.44714 12.0974 2.47369 9.08712 2.47369Z"
        fill="url(#paint0_linear_1304_21758)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7387 7.86037C11.7387 7.86037 12.1727 7.98714 12.4249 8.11063C12.5124 8.15349 12.6638 8.239 12.773 8.35128C12.8799 8.46124 12.9321 8.57267 12.9321 8.57267L14.6426 11.3641L11.8779 11.3653L10.5851 9.01545C10.5851 9.01545 10.3204 8.57519 10.1575 8.44753C10.0216 8.34105 9.96368 8.30315 9.82933 8.30315C9.7358 8.30315 9.17245 8.30315 9.17245 8.30315L9.17297 11.3636L6.72656 11.3646V3.54688H11.6393C11.6393 3.54688 13.8768 3.58594 13.8768 5.64646C13.8768 7.70699 11.7387 7.86037 11.7387 7.86037ZM10.6746 5.24265L9.1936 5.24172L9.19286 6.57103L10.6746 6.57057C10.6746 6.57057 11.3608 6.56851 11.3608 5.89436C11.3608 5.20667 10.6746 5.24265 10.6746 5.24265Z"
        fill="#1E63B6"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1304_21758"
        x1="0.818359"
        y1="0.65625"
        x2="9.30553"
        y2="13.7489"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CBCED0" />
        <stop offset="1" stopColor="#84838B" />
      </linearGradient>
      <clipPath id="clip0_1304_21758">
        <rect
          width="14.4"
          height="10.8"
          fill="white"
          transform="translate(0.800781 0.601562)"
        />
      </clipPath>
    </defs>
  </svg>
);
